import { schema } from "normalizr";
import { arrayOfLabels } from "./schema.labels.jsx";

const projectTemplateTask = new schema.Entity(`projectTemplateTasks`);
const arrayOfProjectTemplateTasks = [projectTemplateTask];

projectTemplateTask.define({
  labels: arrayOfLabels,
});

export { projectTemplateTask, arrayOfProjectTemplateTasks };
